<div *ngFor="let alert of alerts" class="{{alert | alertCssClass}}">
  <p [innerHTML]="alert.message | translate"></p>
  <button mat-icon-button class="alert__close" (click)="removeAlert(alert)">
    <app-icon iconName="cross" iconClassName="icon icon--no-margin icon--extra-small"></app-icon>
  </button>
</div>
